import KinvaDocCreate from './KinvaDocCreate'
export {KinvaDocCreate}
export default KinvaDocCreate
